// TODO: search for "process.env.VUE_ENV" in frontend/ and import this flag there instead
export const isServerEnv = process.env.VUE_ENV === 'server';
